import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import {
  Nullable,
  Location,
  UserWithToken,
  WithMeta,
  LocationType,
  WithData,
} from '@ygoargentina/sdk/api/api.types';
import { z } from 'zod';

export const locationSchema = z.object({
  organizerId: z.number().optional(),
  type: z.nativeEnum(LocationType, {
    message: 'Selecciona un tipo de ubicación',
  }),
  countryId: z.number().min(1, 'Selecciona un país'),
  stateId: z.number().min(1, 'Selecciona una provincia/estado'),
  city: z.string().min(1, 'Ingresa la ciudad'),
  name: z.string().min(1, 'Ingresa el nombre'),
  address: z.string().min(1, 'Ingresa la dirección'),
  latitude: z.string().optional(),
  longitude: z.string().optional(),
  zipCode: z.string().optional(),
  phone: z.string().optional(),
  website: z.string().optional(),
  googleMapsUrl: z.string().optional(),
  organizerIds: z.array(z.number()).optional(),
});

export const listLocations = async (
  user: Nullable<UserWithToken>,
  variables?: Record<string, unknown>
) =>
  getGraphQLQueryClient(user).request<WithMeta<Location>>(
    gql`
      query locations($filters: LocationFilters) {
        data: locations(filters: $filters) {
          data {
            id
            organizerId
            type
            countryId
            stateId
            city
            name
            address
            latitude
            longitude
            zipCode
            phone
            website
            googleMapsUrl
            country {
              id
              name
            }
            state {
              id
              name
            }
            organizer {
              id
              name
            }
          }

          meta {
            total
            perPage
            lastPage
          }
        }
      }
    `,
    { filters: variables }
  );

export const getLocation = async (user: Nullable<UserWithToken>, id: number) =>
  getGraphQLQueryClient(user).request<WithData<Location>>(
    gql`
      query location($id: Int!) {
        data: location(id: $id) {
          id
          organizerId
          type
          countryId
          stateId
          city
          name
          address
          latitude
          longitude
          zipCode
          phone
          website
          googleMapsUrl
          country {
            id
            name
          }
          state {
            id
            name
          }
          organizer {
            id
            name
          }
          organizers {
            organizerId
            organizerName
            favorite
          }
        }
      }
    `,
    { id }
  );

export const createLocation = async (
  user: Nullable<UserWithToken>,
  input: Partial<Location>
) =>
  getGraphQLQueryClient(user).request<WithData<Location>>(
    gql`
      mutation createLocation($input: LocationInput!) {
        data: createLocation(input: $input) {
          id
        }
      }
    `,
    { input }
  );

export const updateLocation = async (
  user: Nullable<UserWithToken>,
  id: number,
  input: Partial<Location>
) =>
  getGraphQLQueryClient(user).request<WithData<Location>>(
    gql`
      mutation updateLocation($id: Int!, $input: UpdateLocationInput!) {
        data: updateLocation(id: $id, input: $input) {
          id
        }
      }
    `,
    { id, input }
  );

export const deleteLocation = async (
  user: Nullable<UserWithToken>,
  id: number
) =>
  getGraphQLQueryClient(user).request<WithData<Location>>(
    gql`
      mutation deleteLocation($id: Int!) {
        data: deleteLocation(id: $id) {
          id
        }
      }
    `,
    { id }
  );
